<template>
<popup-alert
  :title="title"
  :btn_cancel="btn_cancel"
  @close="close">

  <div v-if="type == Const.SUBSC_ATT.REG">
    <div><img :src="`${$store.state.dir}images/regPop.png`" class="w100Im"></div>
    
    <div class="WBkeepAll" style="padding:0px 20px; margin-top:5px;">
      자동차등록증 전면을 위 화면과 같이 카메라 외곽선에 맞춰 촬영해주세요.
    </div>
  </div>

  <div v-if="type == Const.SUBSC_ATT.INSP">
    <div style="position: relative;">
      <img v-show="inspImgType" :src="`${$store.state.dir}images/inspPop1.png`" class="w100Im">
      <img v-show="!inspImgType" :src="`${$store.state.dir}images/inspPop2.png`" class="w100Im">
      <div class="img_c_btn">
        <button class="left_c_btn" v-show="!inspImgType" @click="inspImgType = !inspImgType;"><i class="far fa-chevron-left"></i></button>
        <button class="right_c_btn" v-show="inspImgType" @click="inspImgType = !inspImgType;"><i class="far fa-chevron-right"></i></button>
      </div>
    </div>
  
    <div class="WBkeepAll" style="padding:0px 5px; margin-top:5px;">
      자동차정기검사결과표 정면을 위 화면과 같이 카메라 외곽선에 맞춰 촬영해주세요. 검사표는 <span class="fw400 fs16 colorRed">1면</span>만 촬영해 주세요.
      <div style="font-size:13px;">&#8251; 예시의 검사표가 아닌 서류는 제출이 불가능합니다.</div>
    </div>
  </div>

  <div v-if="type == Const.SUBSC_ATT.PANEL">
    <div class="WBkeepAll" style="padding:0px 20px; margin-bottom:5px;">
      <span class="fw400 fs16 colorRed">자동차 시동이 완전히 켜진 상태</span>에서 계기판 정면을 위 화면과 같이 카메라 외곽선에 맞춰 <span class="fw400 fs16 colorRed">가로</span>로 촬영해주세요.
    </div>
    <div><img :src="`${$store.state.dir}images/panelPop.png`" class="w100Im"></div>
  </div>

</popup-alert>
</template>
<script>
import Const from '../../helpers/Const'
import PopupAlert from '@/components/Popup/PopupAlert.vue';

export default {
  components: {
    PopupAlert,
  },
  props: {
    type: { type: Number ,default:null },
    btn_cancel: {type: Boolean, default: false},
  },
  computed: {
    title() {
      return (this.type == Const.SUBSC_ATT.REG) ? '자동차등록증 촬영 예시'
           : (this.type == Const.SUBSC_ATT.INSP) ? `자동차정기검사결과표 촬영 예시(${this.inspImgType ? '1':'2' }/2)`
           : (this.type == Const.SUBSC_ATT.PANEL) ? '계기판 촬영 예시'
           : '';
    }
  },
  data() {
    return {
      Const,
      inspImgType: true,
    }
  },
  methods: {
    close(value = false) {
      this.inspImgType = true;
      this.$emit('close',value);
    }
  },
}
</script>

<style lang="css" scoped>
</style>